(() => {
  function $(root, sel) { return root.querySelector(sel); }
  function $all(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function scrollQuizIntoView(root) {
    try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  // Save a small summary onto the cart (so cart / cart drawer can render “Quiz results” later)
  async function saveQuizToCartAttributes(resultsObj) {
    const attrs = {
      sh_quiz_v: String(resultsObj.v || "1"),
      sh_quiz_focus: (resultsObj.focus || []).join(", "),
      sh_quiz_picks: (resultsObj.picks || []).join(", "),
      sh_quiz_ts: String(resultsObj.ts || Date.now())
    };
    if (resultsObj.q16 != null && resultsObj.q16 !== "") attrs.sh_quiz_q16 = String(resultsObj.q16);
    if (resultsObj.q16a != null && resultsObj.q16a !== "") attrs.sh_quiz_q16a = String(resultsObj.q16a);
    if (resultsObj.name != null && resultsObj.name !== "") attrs.sh_quiz_name = String(resultsObj.name);
    if (resultsObj.email != null && resultsObj.email !== "") attrs.sh_quiz_email = String(resultsObj.email);
    const payload = { attributes: attrs };

    try {
      const r = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!r.ok) console.warn('[SH Quiz] cart attributes update failed');
    } catch (e) {
      console.warn('[SH Quiz] cart attributes update failed', e);
    }
  }

  // Register quiz lead as Customer (with segment tag). Prefers App Proxy endpoint; falls back to Storefront API if token set.
  async function registerQuizLead(firstName, email, cfg) {
    const tag = (cfg && cfg.quiz_lead_tag) ? String(cfg.quiz_lead_tag).trim() : 'quiz-lead';
    const endpoint = (cfg && cfg.quiz_lead_endpoint) ? String(cfg.quiz_lead_endpoint).trim() : '';
    const shopDomain = (cfg && cfg.shop_domain) ? String(cfg.shop_domain).trim() : '';
    const storefrontToken = (cfg && cfg.storefront_api_token) ? String(cfg.storefront_api_token).trim() : '';

    if (endpoint && shopDomain) {
      try {
        const url = endpoint.replace(/\?.*$/, '') + '?route=create_quiz_lead&json=1&shop=' + encodeURIComponent(shopDomain);
        if (typeof console !== 'undefined') console.log('[SH Quiz] lead create →', url);
        const r = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, first_name: firstName, tag })
        });
        const data = await r.json().catch(() => ({}));
        if (data.ok) {
          if (typeof console !== 'undefined') console.log('[SH Quiz] lead create ok — email:', email, 'shop:', shopDomain, data);
        } else {
          console.warn('[SH Quiz] quiz lead create failed — status:', r.status, 'response:', data);
        }
      } catch (e) {
        console.warn('[SH Quiz] quiz lead create request failed', e);
      }
      return;
    }
    if (typeof console !== 'undefined' && (!endpoint || !shopDomain)) console.warn('[SH Quiz] lead create skipped: missing endpoint or shop_domain', { endpoint: !!endpoint, shopDomain: !!shopDomain });

    if (storefrontToken) {
      try {
        const password = Array.from(crypto.getRandomValues(new Uint8Array(24))).map(b => ('0' + (b & 0xff).toString(16)).slice(-2)).join('');
        const gql = 'mutation customerCreate($input: CustomerCreateInput!) { customerCreate(input: $input) { customer { id } customerUserErrors { code message } } }';
        const r = await fetch('/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
          },
          body: JSON.stringify({
            query: gql,
            variables: {
              input: {
                email,
                password,
                firstName: firstName || 'Quiz',
                acceptsMarketing: true
              }
            }
          })
        });
        const data = await r.json().catch(() => ({}));
        const errs = (data && data.data && data.data.customerCreate && data.data.customerCreate.customerUserErrors) || [];
        if (errs.length > 0) console.warn('[SH Quiz] Storefront customerCreate errors:', errs);
      } catch (e) {
        console.warn('[SH Quiz] Storefront customerCreate failed', e);
      }
    }
  }

  // Update customer profile with quiz results (recommendations + date). Calls App Proxy create_quiz_lead with metafield data.
  async function updateQuizCustomerWithResults(firstName, email, recTitles, cfg) {
    const tag = (cfg && cfg.quiz_lead_tag) ? String(cfg.quiz_lead_tag).trim() : 'quiz-lead';
    const endpoint = (cfg && cfg.quiz_lead_endpoint) ? String(cfg.quiz_lead_endpoint).trim() : '';
    const shopDomain = (cfg && cfg.shop_domain) ? String(cfg.shop_domain).trim() : '';
    if (!endpoint || !shopDomain || !email) {
      if (typeof console !== 'undefined') console.warn('[SH Quiz] profile update skipped: missing endpoint, shop_domain or email', { endpoint: !!endpoint, shopDomain: !!shopDomain, email: !!email });
      return;
    }
    const quizRecommendations = Array.isArray(recTitles) ? recTitles.join(', ') : String(recTitles || '');
    const quizDate = new Date().toISOString().slice(0, 10);
    try {
      const url = endpoint.replace(/\?.*$/, '') + '?route=create_quiz_lead&json=1&shop=' + encodeURIComponent(shopDomain);
      if (typeof console !== 'undefined') console.log('[SH Quiz] profile update →', url, 'recommendations:', quizRecommendations ? quizRecommendations.length + ' chars' : 'none', 'date:', quizDate);
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          first_name: firstName,
          tag,
          quiz_recommendations: quizRecommendations,
          quiz_date: quizDate
        })
      });
      const data = await r.json().catch(() => ({}));
      if (data.ok) {
        if (typeof console !== 'undefined') console.log('[SH Quiz] profile update ok', data);
      } else {
        console.warn('[SH Quiz] quiz profile update failed — status:', r.status, 'response:', data);
      }
    } catch (e) {
      console.warn('[SH Quiz] quiz profile update request failed', e);
    }
  }

  // Resolve Q16 (single) or Q16a (multi) answer to display labels for cart/order attributes
  function getQ16Q16aLabels(questions, answerState) {
    const q16 = questions.find((q) => q.id === "q16_use");
    const q16a = questions.find((q) => q.id === "q16a_existing");
    let q16Label = "";
    let q16aLabel = "";
    if (q16 && q16.options) {
      const ans = answerState.q16_use;
      const key = ans && typeof ans === "object" && ans.key != null ? ans.key : ans;
      const opt = q16.options.find((o) => o.key === key);
      if (opt) q16Label = opt.label;
    }
    if (q16a && q16a.options) {
      const ans = answerState.q16a_existing;
      const keys = Array.isArray(ans) ? ans : [];
      const labels = keys.map((key) => {
        const opt = q16a.options.find((o) => o.key === key);
        return opt ? opt.label : key;
      }).filter(Boolean);
      q16aLabel = labels.join(", ");
    }
    return { q16: q16Label, q16a: q16aLabel };
  }

  // ----- QUIZ DATA (V1) -----
  const QUESTIONS = [
    {
      id: "q1_energy",
      type: "slider4",
      title: "When your day requires sustained effort or concentration, how does your energy typically respond?",
      keyWord: "energy",
      labels: ["Runs out fast", "Variable", "Steady", "Sustains effort"],
      points: [
        { Energy: 6, Recovery: 4 },
        { Energy: 4 },
        {},
        {}
      ]
    },
    {
      id: "q2_clarity",
      type: "slider4",
      title: "As the day progresses, how reliably does your thinking stay clear and focused?",
      keyWord: "focused",
      labels: ["Mental friction", "Mixed", "Clear", "Reliable focus"],
      points: [
        { Focus: 6 },
        { Focus: 4 },
        {},
        {}
      ]
    },
    {
      id: "q3_mood",
      type: "single",
      title: "Under routine pressure or unpredictability, how stable does your mood tend to remain?",
      options: [
        { key: "steady", label: "Easily disrupted", pts: {} },
        { key: "updown", label: "Up and down", pts: { Mood: 4 } },
        { key: "flat", label: "Flat or low", pts: { Mood: 6 } },
        { key: "tense", label: "Stable under pressure", pts: { Mood: 5, Stress: 3, Load: 2 } }
      ]
    },
    {
      id: "q4_diet",
      type: "multi_limit",
      limit: 2,
      title: "How would you describe the pattern of your typical diet?",
      options: [
        { key: "mixed", label: "Mixed / balanced", pts: {} },
        { key: "whole", label: "Mostly whole foods", pts: {} },
        { key: "plant", label: "Plant-focused", pts: { Diet: 2 } },
        { key: "highprotein", label: "High-protein", pts: { Recovery: 2, Energy: 1 } },
        { key: "variable", label: "Highly variable", pts: { Consistency: 2 } },
        { key: "convenience", label: "Convenience-heavy", pts: { Diet: 4, Immunity: 1 } }
      ]
    },
    {
      id: "q5_fv",
      type: "single",
      title: "In your typical week, how frequently do whole foods and vegetables form the base of your meals?",
      options: [
        { key: "most", label: "Most meals", pts: {} },
        { key: "daily", label: "Once or twice a day", pts: { Diet: 1 } },
        { key: "occasional", label: "Occasionally", pts: { Diet: 2, Immunity: 1 } },
        { key: "rarely", label: "Rarely", pts: { Diet: 4, Immunity: 2 } }
      ]
    },
    {
      id: "q6_meals",
      type: "single",
      title: "After most meals, how does your body usually respond?",
      options: [
        { key: "energised", label: "Energised", pts: {} },
        { key: "neutral", label: "Neutral", pts: {} },
        { key: "heavy", label: "Heavy or sluggish", pts: { Digestion: 3, Energy: 2 } },
        { key: "bloated", label: "Bloated or uncomfortable", pts: { Digestion: 5 } }
      ]
    },
    {
      id: "q7_sleep",
      type: "single",
      title: "Overall, how effectively does your sleep support recovery and readiness for the next day?",
      options: [
        { key: "restorative", label: "Consistent and restorative", pts: {} },
        { key: "light", label: "Light or broken", pts: { Sleep: 4, Recovery: 2 } },
        { key: "variable", label: "Variable", pts: { Sleep: 3, Recovery: 1 } },
        { key: "rarely", label: "Rarely refreshing", pts: { Sleep: 6, Recovery: 4 } }
      ]
    },
    {
      id: "q8_load",
      type: "slider4",
      title: "How demanding does your current day-to-day life feel on your energy and attention?",
      keyWord: "attention",
      labels: ["Calm", "Near full", "Full", "Very demanding"],
      points: [
        {},
        { Stress: 3, Load: 3 },
        { Stress: 4, Load: 4 },
        { Stress: 6, Load: 6, Recovery: 2 }
      ]
    },
    {
      id: "q8a_alcohol",
      type: "single",
      title: "How often does alcohol fit into your week?",
      options: [
        { key: "none", label: "Not at all", pts: {} },
        { key: "occasional", label: "Occasionally (1–2 times a week or less)", pts: { Load: 1 } },
        { key: "mostweeks", label: "Socially most weeks", pts: { Load: 3, Recovery: 1 } },
        { key: "frequent", label: "Frequently", pts: { Load: 5, Recovery: 3, Sleep: 1 } }
      ]
    },
    {
      id: "q9_recover",
      type: "single",
      title: "After busy or demanding days, how well do you feel your body recovers?",
      options: [
        { key: "bounce", label: "I bounce back quickly", pts: {} },
        { key: "day2", label: "It takes a day or two", pts: { Recovery: 3 } },
        { key: "rundown", label: "I often feel run down", pts: { Recovery: 4, Energy: 2 } },
        { key: "incomplete", label: "Recovery feels incomplete", pts: { Recovery: 6, Energy: 3 } }
      ]
    },
    {
      id: "q10_activity",
      type: "single",
      title: "Which best describes your usual level of physical demand?",
      options: [
        { key: "sed", label: "Mostly sedentary", pts: { Consistency: 1 } },
        { key: "light", label: "Light, regular movement", pts: {} },
        { key: "moderate", label: "Moderate exercise", pts: { Recovery: 2 } },
        { key: "high", label: "High physical demand", pts: { Recovery: 4, Load: 2 } }
      ]
    },
    {
      id: "q11_types",
      type: "multi_limit",
      limit: 3,
      title: "What types of physical activity make up most of your movement? (Choose up to 3)",
      options: [
        { key: "walk", label: "Walking / low-impact movement", pts: {} },
        { key: "strength", label: "Resistance or strength training", pts: { Recovery: 2 } },
        { key: "endurance", label: "Cardio / endurance", pts: { Recovery: 2 } },
        { key: "sport", label: "Sport or mixed activity", pts: { Recovery: 2 } },
        { key: "none", label: "Very little structured activity", pts: { Consistency: 2 } }
      ]
    },
    {
      id: "q12_response",
      type: "single",
      title: "After physical activity, how does your body usually respond?",
      options: [
        { key: "strong", label: "Strong and capable", pts: {} },
        { key: "neutral", label: "Neutral", pts: {} },
        { key: "sore", label: "Tight or sore", pts: { Recovery: 3 } },
        { key: "fatigued", label: "Fatigued longer than expected", pts: { Recovery: 5, Energy: 2 } }
      ]
    },
    {
      id: "q13_consistency",
      type: "single",
      title: "How stable and repeatable do your daily routines feel over time?",
      options: [
        { key: "very", label: "Very consistent", pts: {} },
        { key: "mostly", label: "Mostly consistent", pts: { Consistency: 1 } },
        { key: "irregular", label: "Irregular", pts: { Consistency: 3 } },
        { key: "hard", label: "Hard to maintain", pts: { Consistency: 5 } }
      ]
    },
    {
      id: "q14_obstacles",
      type: "multi_limit",
      limit: 2,
      title: "What most often limits your ability to stay consistent? (Choose up to 2)",
      options: [
        { key: "time", label: "Time", pts: { Consistency: 2 } },
        { key: "energy", label: "Energy", pts: { Energy: 2, Consistency: 2 } },
        { key: "stress", label: "Stress", pts: { Stress: 3, Load: 2, Consistency: 2 } },
        { key: "travel", label: "Travel", pts: { Load: 2, Consistency: 2 } },
        { key: "motivation", label: "Motivation", pts: { Consistency: 2, Mood: 1 } },
        { key: "uncertainty", label: "Uncertainty about what matters most", pts: { Clarity: 2, Consistency: 2 } }
      ]
    },
    {
      id: "q15_goals",
      type: "multi_limit",
      limit: 3,
      title: "Which outcomes are you most looking to support right now? (Choose up to 3)",
      options: [
        { key: "energy", label: "Steady energy", pts: { Energy: 10 } },
        { key: "focus", label: "Mental clarity and focus", pts: { Focus: 10, Clarity: 6 } },
        { key: "digestion", label: "Digestive comfort", pts: { Digestion: 10 } },
        { key: "immunity", label: "Immune resilience", pts: { Immunity: 10 } },
        { key: "recovery", label: "Physical recovery", pts: { Recovery: 10 } },
        { key: "mood", label: "Mood balance", pts: { Mood: 10 } },
        { key: "consistency", label: "Overall consistency", pts: { Consistency: 10 } }
      ]
    },
    {
      id: "q16_use",
      type: "single",
      title: "Do supplements currently play a role in your routine?",
      options: [
        { key: "regularly", label: "Regularly", pts: {} },
        { key: "occasionally", label: "Occasionally", pts: {} },
        { key: "tried", label: "Tried before", pts: {} },
        { key: "not", label: "Not currently", pts: { Consistency: 1 } }
      ]
    },
    {
      id: "q16a_existing",
      type: "multi_optional",
      title: "Which of the following are already part of your routine? (Optional)",
      options: [
        { key: "vitd", label: "Vitamin D", pts: {} },
        { key: "protein", label: "Protein powder", pts: {} },
        { key: "nutrient", label: "Nutrient powder", pts: {} },
        { key: "nattokainase", label: "Nattokainase", pts: {} },
        { key: "vitc", label: "Vitamin C", pts: {} },
        { key: "bcomplex", label: "B-complex", pts: {} },
        { key: "b12", label: "Vitamin B12", pts: {} },
        { key: "b6", label: "Vitamin B6", pts: {} },
        { key: "folate", label: "Folate", pts: {} },
        { key: "mag", label: "Magnesium", pts: {} },
        { key: "zinc", label: "Zinc", pts: {} },
        { key: "iron", label: "Iron", pts: {} },
        { key: "selenium", label: "Selenium", pts: {} },
        { key: "iodine", label: "Iodine", pts: {} },
        { key: "omega3", label: "Omega-3", pts: {} },
        { key: "probiotics", label: "Probiotics", pts: {} },
        { key: "electrolytes", label: "Electrolytes", pts: {} },
        { key: "none", label: "None of the above", pts: {} }
      ]
    },
    {
      id: "q17_safety",
      type: "checkbox",
      title: "Before we share your results",
      checkboxLabel: "I understand (If you are currently under medical care, pregnant, or taking prescribed medication, we recommend reviewing any new supplements with a qualified professional.)",
      points: {}
    }
  ];


  // --- SETS: Arc + intros/outros (your copy) ---
  // Index ranges are 0-based: q1 is index 0.
const SETS = [
  {
    id: "set1",
    start: 0,
    end: 2, // Q1–Q3
    introTitle: "Let's understand today.",
    introBody: [
      "A snapshot of your day-to-day life right now.",
      "No judgement — just patterns."
    ],
    outroTitle: "That gives us a baseline",
    outroBody: [ ]
  },
  {
    id: "set2",
    start: 3,
    end: 6, // Q4–Q7
    introTitle: "How your body responds",
    introBody: [
      "Now we'll look at how food, sleep, and digestion tend to show up for you."
    ],
    outroTitle: "Some patterns are forming",
    outroBody: [ ]
  },
  {
    id: "set3",
    start: 7,
    end: 9, // Q8–Q9 (+ Q8a alcohol)
    introTitle: "Life load and recovery",
    introBody: [
      "This part helps us understand the load your system is carrying — and how well it gets a chance to reset."
    ],
    outroTitle: "That context matters",
    outroBody: [
      "When load is visible, solutions become more realistic."
    ]
  },
  {
    id: "set4",
    start: 10,
    end: 14, // Q10–Q14
    introTitle: "Consistency and friction",
    introBody: [
      "Consistency isn't willpower — it's alignment.",
      "Let's look at what helps or hinders yours."
    ],
    outroTitle: "That explains a lot",
    outroBody: [
      "Understanding friction helps us match sustainable nourishment."
    ]
  },
  {
    id: "set5",
    start: 15,
    end: 18, // Q15–Q17 (+ Q15a)
    introTitle: "What matters most right now",
    introBody: [
      "Finally, we'll focus on where you'd most like support right now."
    ],
    outroTitle: "We have what we need",
    outroBody: [
      "Taken together, your answers form a clear direction."
    ]
  }
];

  // Band messages (copy-ready)
  const BAND_MESSAGES = {
    clarity: {
      low:  "You're not alone here. Many people start this process feeling unsure where to focus — that's what this is designed for. Your answers give us a clear place to begin.",
      mid:  "You already have a sense of what matters. That's a strong position to be in.",
      high: "You've clearly spent time thinking about your health.",
      vhigh:"You approach your health with intention. Great, let's refine rather than restart — and build more sustainable outcomes."
    },
    energy: {
      low:  "Low energy often isn't about effort — it's about support. Your answers help us understand what may be quietly draining you.",
      mid:  "Your energy isn't broken — it's just inconsistent. Patterns like this usually respond well to simple, steady adjustments.",
      high: "You've built some reliable foundations already. That gives us a strong base to work from.",
      vhigh:"You seem tuned in to how your body responds. That awareness is one of the most valuable tools in long-term health."
    },
    consistency: {
      low:  "Consistency is hard when life is busy. What matters is that you're paying attention — that's where change actually starts.",
      mid:  "You've already experimented with routines. With the right structure, those efforts usually become easier to maintain.",
      high: "You've shown that steady habits are possible for you. This allows us to focus on quality, not just repetition.",
      vhigh:"You clearly value rhythm over intensity. That mindset tends to produce the most durable results."
    },
    short: {
      low:  "You're exactly where many people begin — this is useful.",
      mid:  "You're building awareness — the next steps will feel clearer.",
      high: "You've already laid groundwork — we can now refine.",
      vhigh:"You bring intention — this lets us personalise deeply."
    }
  };

  // Friendly labels for “patterns so far”
  const DOMAIN_LABELS = {
    Energy: "Energy",
    Focus: "Clarity",
    Mood: "Mood",
    Recovery: "Recovery",
    Sleep: "Sleep",
    Stress: "Stress",
    Load: "Life load",
    Diet: "Nutrition",
    Digestion: "Digestion",
    Immunity: "Immune resilience",
    Consistency: "Consistency",
    Clarity: "Understanding"
  };

  // --- Archetype system (conversion-optimised: identity hook, focus line, why bullets, CTA, subscription) ---
  const ARCHETYPES = [
    {
      id: "energy_burnout",
      label: "Sustained Energy Deficit",
      domainWeights: { Energy: 2, Recovery: 2 },
      headline: "Your System Is Running on Empty",
      patternLabel: "Sustained Energy Load",
      topLine: "Your answers suggest output has been exceeding recovery for some time. This doesn't always feel dramatic — it feels like energy fading earlier than it should, recovery taking longer, effort feeling heavier than it used to. When recovery falls behind, consistency drops. This isn't about pushing harder. It's about rebuilding the foundation that powers everything else.",
      focusLine: "Recovery · Output Stability · Energy Conversion · Mineral Repletion",
      whyBullets: [
        "Your energy appears to fade under sustained effort.",
        "Recovery may not be keeping pace with daily demand.",
        "Output feels effortful instead of steady.",
        "Foundational support could help reduce cumulative fatigue."
      ],
      ctaLabel: "Add my 'Energy Reset System' to cart",
      subscriptionLine: "Because steady input creates steady energy."
    },
    {
      id: "stress_overloaded",
      label: "Stress Load Exceeding Capacity",
      domainWeights: { Stress: 2, Load: 2, Mood: 1 },
      headline: "Your Nervous System Is Carrying Ongoing Load",
      patternLabel: "Demand > Buffer",
      topLine: "Even when things feel \"manageable,\" your system may be absorbing more stress than it's releasing. Over time that can show up as lower tolerance, shallow recovery, tension that lingers. Stress isn't just emotional — it's physiological. When buffering improves, resilience improves. The goal here isn't escape. It's stronger internal capacity.",
      focusLine: "Nervous System Buffering · Stress Resilience · Mineral Stability · Inflammation Modulation",
      whyBullets: [
        "Ongoing demand may be exceeding your recovery buffer.",
        "Tension or pressure feels cumulative.",
        "Stress tolerance may fluctuate under load.",
        "Internal buffering systems may need reinforcement."
      ],
      ctaLabel: "Add my 'Capacity Lift System' to cart",
      subscriptionLine: "Because stress doesn't take breaks."
    },
    {
      id: "brain_focus",
      label: "Cognitive Strain & Focus Drift",
      domainWeights: { Focus: 2, Clarity: 2 },
      headline: "Your Focus Is Working Harder Than It Should",
      patternLabel: "Cognitive Strain",
      topLine: "Your responses suggest clarity and sustained attention are under pressure. That can look like mental friction, midday fade, increased effort for simple tasks. This isn't about willpower. Mental output depends on structural and biochemical support. Reinforce the system, and focus becomes steadier — not forced.",
      focusLine: "Mental Clarity · Neurotransmitter Support · Structural Brain Resilience · Energy Stability",
      whyBullets: [
        "Focus may fade as the day progresses.",
        "Mental output feels effortful rather than fluid.",
        "Sustained concentration requires disproportionate energy.",
        "Structural brain support could improve steadiness."
      ],
      ctaLabel: "Add my 'Mental Edge System' to cart",
      subscriptionLine: "Clarity improves with repetition."
    },
    {
      id: "recovery_lag",
      label: "Recovery Lag",
      domainWeights: { Recovery: 2, Sleep: 2 },
      headline: "Recovery Isn't Fully Resetting You",
      patternLabel: "Incomplete Restoration",
      topLine: "Your sleep and downtime may not be restoring readiness the way they should. When recovery lags: effort accumulates, muscle tension lingers, energy feels borrowed. Recovery is not passive. It's active repair. Supporting recovery reduces the cost of tomorrow.",
      focusLine: "Sleep Support · Nervous Reset · Muscle Recovery · Recovery Signalling",
      whyBullets: [
        "Sleep may not be fully restorative.",
        "Physical effort feels cumulative.",
        "Recovery windows seem extended.",
        "Nervous system reset may be incomplete."
      ],
      ctaLabel: "Add My 'Recovery Foundation System' to cart",
      subscriptionLine: "Repair requires consistency."
    },
    {
      id: "digestive_load",
      label: "Digestive Load & Tolerance Strain",
      domainWeights: { Digestion: 2, Diet: 1 },
      headline: "Your System May Be Working Too Hard After Meals",
      patternLabel: "Processing Strain",
      topLine: "Your responses suggest digestion and tolerance could use support. When digestion is under load: energy diverts, meals feel heavy, nutrient absorption may be inconsistent. It's not just about what you eat. It's about how well you process it. Strengthen processing, and everything downstream improves.",
      focusLine: "Digestive Efficiency · Nutrient Utilisation · Enzymatic Support · Post-Meal Energy",
      whyBullets: [
        "Meals may leave you heavy or sluggish.",
        "Digestive comfort may fluctuate.",
        "Nutrient absorption may be inconsistent.",
        "Energy may dip after eating."
      ],
      ctaLabel: "Add My 'Digestive Lift System' to cart",
      subscriptionLine: "Consistent input supports smoother processing."
    },
    {
      id: "immunity_rundown",
      label: "Immune Readiness Gap",
      domainWeights: { Immunity: 3 },
      headline: "Your Bounce-Back Capacity Could Be Stronger",
      patternLabel: "Immune Readiness Under Demand",
      topLine: "Your system may be slower to reset during busy or demanding periods. That can mean lingering fatigue, longer recovery windows, reduced resilience during pressure. Immune readiness isn't about extremes. It's about coordinated baseline support. Build the base, improve the response.",
      focusLine: "Immune Coordination · Recovery Speed · Structural Support · Resilience Under Demand",
      whyBullets: [
        "Recovery from busy periods may feel prolonged.",
        "Bounce-back capacity could be stronger.",
        "Resilience may fluctuate under pressure.",
        "Baseline immune coordination may benefit from reinforcement."
      ],
      ctaLabel: "Add my 'Immune Strength System' to cart",
      subscriptionLine: "Immune support works best when steady."
    },
    {
      id: "bone_structural",
      label: "Structural & Musculoskeletal Support Need",
      domainWeights: { Recovery: 1, Load: 2 },
      headline: "Your Physical System Is Carrying Load",
      patternLabel: "Structural Demand",
      topLine: "Your answers suggest physical resilience and structural support could benefit from reinforcement. Over time this may feel like tightness, reduced recovery, greater fatigue after exertion. Movement is only as strong as the foundation behind it. Rebuild structural support, and output feels more sustainable.",
      focusLine: "Bone Integrity · Muscle Function · Mineral Utilisation · Structural Resilience",
      whyBullets: [
        "Physical load may feel cumulative.",
        "Muscle recovery may lag.",
        "Structural resilience could benefit from reinforcement.",
        "Mineral support may improve durability."
      ],
      ctaLabel: "Add my 'Physical Reinforce System' to cart",
      subscriptionLine: "Structure strengthens with repetition."
    },
    {
      id: "mineral_depletion",
      label: "Foundational Mineral Depletion",
      domainWeights: { Diet: 2, Consistency: 1 },
      headline: "Your Foundation May Need Rebuilding",
      patternLabel: "Mineral Undersupply",
      topLine: "Core minerals support energy production, nerve signalling, muscle function, stress response. When foundations thin out, multiple systems feel it. Rebuilding base mineral support often improves more than one domain at once. Start with the base. Everything stacks from there.",
      focusLine: "Core Mineral Restoration · Nervous System Stability · Energy Pathways · Structural Support",
      whyBullets: [
        "Multiple systems may be affected by low mineral availability.",
        "Energy, stress response and muscle tone may overlap.",
        "Foundational repletion could improve more than one domain."
      ],
      ctaLabel: "Add my 'Mineral Restore System' to cart",
      subscriptionLine: "Foundations require repetition."
    },
    {
      id: "system_inconsistency",
      label: "System Inconsistency / High Friction",
      domainWeights: { Consistency: 3 },
      headline: "The Problem Isn't Effort — It's Friction",
      patternLabel: "Inconsistent System",
      topLine: "Your answers suggest you don't lack intention — you lack a simple repeatable structure. When systems are unclear: motivation fluctuates, decisions drain energy, support becomes irregular. The goal isn't intensity. It's simplicity. Reduce friction. Increase repeatability. That's where results stabilise.",
      focusLine: "Simplicity · Repeatability · Energy Stability · Friction Reduction",
      whyBullets: [
        "Health support may feel irregular.",
        "Decision fatigue reduces consistency.",
        "Motivation fluctuates without structure.",
        "A simple repeatable system would reduce friction."
      ],
      ctaLabel: "Add my 'Simply Solid System' to cart",
      subscriptionLine: "Consistency beats intensity."
    },
    {
      id: "maintenance",
      label: "Maintenance & Optimisation",
      domainWeights: {},
      headline: "You're Building From Strength",
      patternLabel: "Maintenance & Refinement",
      topLine: "You've already established useful habits and awareness. Now the focus shifts from fixing → refining. Support here protects consistency, maintains structural balance, strengthens long-term resilience. This isn't about overhaul. It's about durability. Optimisation is subtle — but powerful.",
      focusLine: "Quality Refinement · Long-Term Stability · Structural Balance · Durability",
      whyBullets: [
        "You already maintain useful routines.",
        "Foundational awareness is present.",
        "Refinement — not overhaul — is appropriate.",
        "Consistency is your strength."
      ],
      ctaLabel: "Add my 'Core Maintenance System' to cart",
      subscriptionLine: "Maintenance works best when uninterrupted."
    }
  ];

  // Per-archetype, per-product: role (e.g. "Your Recovery Anchor") + benefit line
  const ARCHETYPE_PRODUCT_BENEFITS = {
    energy_burnout: {
      b_complex: { role: "Your Energy Conversion Driver", benefit: "Supports efficient cellular energy production so effort feels smoother — not forced." },
      mineral_complex: { role: "Your Recovery Anchor", benefit: "Helps reduce energy loss under stress and stabilise daily output." }
    },
    stress_overloaded: {
      mineral_complex: { role: "Your Stress Buffer", benefit: "Supports nervous system buffering so stress feels less physiologically draining." },
      omega_3: { role: "Your Inflammation Regulator", benefit: "Supports calm focus and structural resilience during sustained demand." }
    },
    brain_focus: {
      omega_3: { role: "Your Structural Brain Support", benefit: "Supports structural brain integrity and mental resilience." },
      b_complex: { role: "Your Clarity Driver", benefit: "Supports neurotransmitter pathways involved in clarity and sustained focus." }
    },
    recovery_lag: {
      mineral_complex: { role: "Your Recovery Anchor", benefit: "Supports muscle relaxation and nervous system recovery signalling." },
      d3_k2: { role: "Your Resilience Support", benefit: "Supports physical resilience and coordinated recovery pathways." }
    },
    digestive_load: {
      mineral_complex: { role: "Your Digestive Base", benefit: "Supports enzymatic processes involved in digestion and nutrient utilisation." },
      b_complex: { role: "Your Processing Support", benefit: "Supports energy availability required for efficient digestive processing." }
    },
    immunity_rundown: {
      vit_c: { role: "Your Immune Defender", benefit: "Supports immune defence and resilience during periods of demand." },
      d3_k2: { role: "Your Immune Coordinator", benefit: "Supports coordinated immune system signalling." }
    },
    bone_structural: {
      d3_k2: { role: "Your Structural Foundation", benefit: "Supports bone strength and mineral distribution." },
      mineral_complex: { role: "Your Muscle Support", benefit: "Supports muscle contraction, relaxation and structural stability." }
    },
    mineral_depletion: {
      mineral_complex: { role: "Your Foundation Builder", benefit: "Rebuilds essential mineral levels that support energy, nerve signalling and muscle function." }
    },
    system_inconsistency: {
      mineral_complex: { role: "Your Daily Base", benefit: "Provides a stable daily foundation that reduces system complexity." },
      b_complex: { role: "Your Steady Energy Support", benefit: "Supports steady energy so routines are easier to maintain." }
    },
    maintenance: {
      b_complex: { role: "Your Foundation Maintainer", benefit: "Maintains strong energy foundations." },
      mineral_complex: { role: "Your Long-Term Balance", benefit: "Supports long-term structural and nervous system balance." }
    }
  };

  function resolvePrimaryArchetype(domainScores) {
    let primary = null;
    let primaryScore = -1;
    let secondary = null;
    let secondaryScore = -1;
    const total = Object.values(domainScores).reduce((a, b) => a + b, 0);
    for (const arch of ARCHETYPES) {
      let score = arch.id === "maintenance" ? Math.max(0, 80 - total * 0.5) : 0;
      for (const [domain, weight] of Object.entries(arch.domainWeights || {})) {
        score += (domainScores[domain] || 0) * weight;
      }
      if (score > primaryScore) {
        secondaryScore = primaryScore; secondary = primary;
        primaryScore = score; primary = arch;
      } else if (score > secondaryScore) {
        secondaryScore = score; secondary = arch;
      }
    }
    return { primary: primary || ARCHETYPES[ARCHETYPES.length - 1], secondary: secondary || null };
  }

  function getArchetypeBenefitForProduct(archetypeId, productKey) {
    const byArch = ARCHETYPE_PRODUCT_BENEFITS[archetypeId];
    const entry = byArch && byArch[productKey];
    if (entry && (entry.role || entry.benefit)) return { role: entry.role || "", benefit: entry.benefit || "" };
    return { role: "", benefit: "Supports your foundations as part of a Core Health daily system." };
  }

  // Product strengths (you already boosted D3 + C for Immunity testing)
  const PRODUCT_STRENGTH = {
    omega_3:         { Focus: 5, Mood: 4, Recovery: 3, Immunity: 1, Clarity: 2 },
    mineral_complex: { Recovery: 5, Stress: 4, Sleep: 4, Energy: 2, Load: 2 },
    b_complex:       { Energy: 5, Focus: 4, Mood: 4, Stress: 3, Clarity: 2, Load: 1 },

    // boosted so they can compete when "Immunity" is strong
    d3_k2:           { Immunity: 7, Mood: 2, Recovery: 2 },
    vit_c:           { Immunity: 6, Recovery: 2, Load: 2 }
  };

  function topDomains(domainScores, n = 3) {
    const entries = Object.entries(domainScores).filter(([, v]) => v > 0);
    entries.sort((a, b) => b[1] - a[1]);
    return entries.slice(0, n).map(([k]) => k);
  }

  function scoreProducts(domainScores, productsCfg) {
    const keys = Object.keys(productsCfg || {});
    const scored = keys.map((key) => {
      const strengths = PRODUCT_STRENGTH[key] || {};
      let score = 0;
      for (const [domain, pts] of Object.entries(domainScores)) {
        const w = strengths[domain] || 0;
        score += pts * w;
      }
      return { key, score };
    });

    scored.sort((a, b) => b.score - a.score);

    // ✅ You asked earlier: yes, this is intentionally capped at 3 recommendations.
    // It keeps the output simple and “doable”. We can change this later if you want.
    const picks = scored.filter(x => x.score > 0).slice(0, 3);

    if (!picks.length) return [{ key: "b_complex", score: 1 }, { key: "mineral_complex", score: 1 }];
    return picks;
  }

  function mergePoints(target, pts) {
    for (const [k, v] of Object.entries(pts || {})) {
      target[k] = (target[k] || 0) + v;
    }
  }

  function computeDomainScores(answerState, limitIndexInclusive = null) {
    const scores = {};
    for (let i = 0; i < QUESTIONS.length; i++) {
      if (typeof limitIndexInclusive === 'number' && i > limitIndexInclusive) break;
      const q = QUESTIONS[i];
      const ans = answerState[q.id];

      if (q.type === 'slider4' || q.type === 'slider3') {
        if (typeof ans === 'number') mergePoints(scores, q.points[ans] || {});
      } else if (q.type === 'single') {
        if (ans && ans.key) mergePoints(scores, ans.pts);
      } else if (q.type === 'multi' || q.type === 'multi_optional' || q.type === 'multi_limit') {
        if (Array.isArray(ans)) {
          ans.forEach(key => {
            const opt = q.options.find(o => o.key === key);
            if (opt) mergePoints(scores, opt.pts);
          });
        }
      } else if (q.type === 'checkbox') {
        // no points
      }
    }
    return scores;
  }

  // --- Max possible points per domain (for % bands) ---
  function maxPointsPerDomainThroughIndex(limitIndexInclusive) {
    const max = {};
    const capIndex = (typeof limitIndexInclusive === 'number') ? limitIndexInclusive : (QUESTIONS.length - 1);

    for (let i = 0; i <= capIndex; i++) {
      const q = QUESTIONS[i];

      if (q.type === 'slider4' || q.type === 'slider3') {
        const best = {};
        (q.points || []).forEach(p => mergePoints(best, p));
        // BUT: mergePoints sums; we want per-domain maximum across options
        // So redo correctly:
        const per = {};
        (q.points || []).forEach(p => {
          for (const [k, v] of Object.entries(p || {})) {
            per[k] = Math.max(per[k] || 0, v);
          }
        });
        mergePoints(max, per);
      }

      if (q.type === 'single') {
        const per = {};
        (q.options || []).forEach(o => {
          for (const [k, v] of Object.entries(o.pts || {})) {
            per[k] = Math.max(per[k] || 0, v);
          }
        });
        mergePoints(max, per);
      }

      if (q.type === 'multi_limit') {
        const per = {};
        // choose top 'limit' options per domain
        const lim = q.limit || 1;
        const domainBuckets = {};
        (q.options || []).forEach(o => {
          for (const [k, v] of Object.entries(o.pts || {})) {
            if (!domainBuckets[k]) domainBuckets[k] = [];
            domainBuckets[k].push(v);
          }
        });
        for (const [k, arr] of Object.entries(domainBuckets)) {
          arr.sort((a, b) => b - a);
          per[k] = arr.slice(0, lim).reduce((s, n) => s + n, 0);
        }
        mergePoints(max, per);
      }

      if (q.type === 'multi_optional') {
        // optional, can be many — we cap to avoid “infinite max”
        // Here it has no points anyway, so safe to ignore.
      }
    }

    return max;
  }

  function bandFromPercent(pct) {
    if (pct >= 86) return 'vhigh';
    if (pct >= 66) return 'high';
    if (pct >= 31) return 'mid';
    return 'low';
  }

  function getEncouragementForSet(setIdx, scoresSoFar, maxSoFar) {
    // Keep it simple + human: 1–2 messages.
    // We map “clarity” from Focus/Clarity; “energy” from Energy/Recovery; “consistency” from Consistency.
    const focusScore = (scoresSoFar.Focus || 0) + (scoresSoFar.Clarity || 0);
    const focusMax = (maxSoFar.Focus || 0) + (maxSoFar.Clarity || 0);

    const energyScore = (scoresSoFar.Energy || 0) + (scoresSoFar.Recovery || 0);
    const energyMax = (maxSoFar.Energy || 0) + (maxSoFar.Recovery || 0);

    const consScore = (scoresSoFar.Consistency || 0);
    const consMax = (maxSoFar.Consistency || 0);

    const pctFocus = focusMax > 0 ? Math.round((focusScore / focusMax) * 100) : 0;
    const pctEnergy = energyMax > 0 ? Math.round((energyScore / energyMax) * 100) : 0;
    const pctCons  = consMax  > 0 ? Math.round((consScore  / consMax)  * 100) : 0;

    const bandFocus = bandFromPercent(pctFocus);
    const bandEnergy = bandFromPercent(pctEnergy);
    const bandCons = bandFromPercent(pctCons);

    // Per set, choose the most relevant pair
    if (setIdx === 0) {
      return [
        BAND_MESSAGES.energy[bandEnergy],
        BAND_MESSAGES.clarity[bandFocus],
        "We'll use this to shape recommendations that match how you actually live."
      ];
    }

    if (setIdx === 1) {
      return [
        BAND_MESSAGES.consistency[bandCons],
        BAND_MESSAGES.energy[bandEnergy],
        "We'll use this to shape recommendations that match how you actually live."
      ];
    }

    if (setIdx === 2) {
      return [
        BAND_MESSAGES.short[bandFocus],
        "We'll use this to shape recommendations that match how you actually live."
      ];
    }

    // set 4
    return [
      BAND_MESSAGES.short[bandFocus],
      "We'll use this to shape recommendations that match how you actually live."
    ];
  }

  function humanDomainList(keys) {
    return (keys || []).map(k => DOMAIN_LABELS[k] || k);
  }

  // ✅ Resolve Shopify selling plan IDs per product via /products/<handle>.js
  const __shqSellingPlanCache = new Map(); // key: productUrl => [planIds]

  function __normalizeProductJsUrl(productUrl) {
    if (!productUrl) return '';
    const u = String(productUrl).trim();
    if (!u) return '';
    if (u.endsWith('.js')) return u;
    return `${u}.js`;
  }

  async function __getShopifySellingPlanIdsForProduct(productUrl) {
    const key = String(productUrl || '');
    if (__shqSellingPlanCache.has(key)) return __shqSellingPlanCache.get(key);

    const jsUrl = __normalizeProductJsUrl(productUrl);
    if (!jsUrl) {
      __shqSellingPlanCache.set(key, []);
      return [];
    }

    try {
      const r = await fetch(jsUrl, { credentials: 'same-origin' });
      if (!r.ok) {
        __shqSellingPlanCache.set(key, []);
        return [];
      }
      const p = await r.json();
      const g = (p.selling_plan_groups || [])[0];
      const plans = (g && g.selling_plans) ? g.selling_plans : [];
      const ids = plans.map(sp => Number(sp.id)).filter(n => Number.isFinite(n) && n > 0);
      __shqSellingPlanCache.set(key, ids);
      return ids;
    } catch (e) {
      __shqSellingPlanCache.set(key, []);
      return [];
    }
  }

  function addToCart(items, redirectUrl, shouldRedirect = true) {
    const postAdd = async (payload) => {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      let data = null;
      try { data = await r.json(); } catch (e) {}

      if (!r.ok) {
        const err = data || {};
        throw {
          status: r.status,
          message: err.message || 'Cart Error',
          description: err.description || err.message || 'Add failed',
          raw: err,
          sent: payload
        };
      }
      return data;
    };

    // Try each candidate plan id as a SUBSCRIPTION add.
    // If all candidates fail with 422, throw (do NOT silently downgrade to one-time).
    const addOneWithFallback = async (payload) => {
      const candidates = Array.isArray(payload.__planCandidates)
        ? payload.__planCandidates.filter(Boolean).map((x) => Number(x))
        : [];

      const base = { ...payload };
      delete base.__planCandidates;

      if (!candidates.length) {
        console.error('[SH Quiz] No selling plan candidates for item:', base);
        throw {
          status: 422,
          message: 'Subscription add failed',
          description: 'No selling plan candidates were provided for this item',
          raw: base
        };
      }

      let last422 = null;

      for (const planId of candidates) {
        try {
          const attempt = { ...base, selling_plan: planId }; // ✅ correct field for /cart/add.js
          console.log('[SH Quiz] add.js payload', { id: attempt.id, quantity: attempt.quantity, selling_plan: planId });
          return await postAdd(attempt);
        } catch (e) {
          if (e && e.status === 422) {
            last422 = e;
            continue;
          }
          throw e;
        }
      }

      throw last422 || {
        status: 422,
        message: 'Subscription add failed',
        description: 'Selling plan could not be applied',
        raw: base
      };
    };

    return (async () => {
      for (const payload of items) {
        await addOneWithFallback(payload);
      }
      if (shouldRedirect) window.location.href = redirectUrl || '/cart';
    })();
  }
function setSliderFill(input) {
  const min = Number(input.min || 0);
  const max = Number(input.max || 100);
  const val = Number(input.value || 0);
  const pct = ((val - min) / (max - min)) * 100;
  input.style.setProperty('--shq-slider-pct', pct + '%');
}

  function setKnobPosition(knobEl, value, max) {
    if (!knobEl || max <= 0) return;
    // Get the trackWrap element (parent of knob)
    const trackWrap = knobEl.parentElement;
    if (!trackWrap) return;
    
    // Calculate percentage (0-100)
    const pct = (value / max) * 100;
    
    // Get computed styles
    const trackWrapWidth = trackWrap.offsetWidth;
    const thumbSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--shq-slider-thumb')) || 28;
    // No padding now - slider goes to edges
    // Knob starts centered at left edge (thumbSize/2) and moves across full width minus thumb size
    const innerWidth = trackWrapWidth - thumbSize;
    
    // Calculate left position: thumbSize/2 (center at left edge) + (percentage of inner width)
    const leftPos = (thumbSize / 2) + (pct / 100 * innerWidth);
    knobEl.style.setProperty('--shq-knob-left', `${leftPos}px`);
  }

  // Format question title with first word, key word, and last word bold (for emphasis).
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function formatQuestionTitle(title, keyWord) {
    if (!title || !title.trim()) return '';
    const words = title.trim().split(/\s+/);
    if (words.length === 0) return '';
    const norm = (w) => w.toLowerCase().replace(/[?,.]/g, '');
    const keyNorm = keyWord ? norm(keyWord) : '';
    let out = '<strong>' + escapeHtml(words[0]) + '</strong>';
    for (let i = 1; i < words.length - 1; i++) {
      out += ' ';
      if (keyNorm && norm(words[i]) === keyNorm) {
        out += '<strong>' + escapeHtml(words[i]) + '</strong>';
      } else {
        out += escapeHtml(words[i]);
      }
    }
    if (words.length > 1) {
      out += ' <strong>' + escapeHtml(words[words.length - 1]) + '</strong>';
    }
    return out;
  }

  // ----- UI RENDERERS -----
  function renderSlider(root, q, currentValue) {
    const wrap = document.createElement('div');
    wrap.className = 'shq__sliderWrap';

    const trackWrap = document.createElement('div');
    trackWrap.className = 'shq__sliderTrackWrap';

    const n = q.labels.length;
    const maxIndex = n - 1;

    const ticks = document.createElement('div');
    ticks.className = 'shq__sliderTicks';
    ticks.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < n; i++) {
      const tick = document.createElement('div');
      tick.className = 'shq__sliderTick';
      ticks.appendChild(tick);
    }
    trackWrap.appendChild(ticks);

    const input = document.createElement('input');
    input.className = 'shq__slider';
    input.type = 'range';
    input.min = 0;
    input.max = maxIndex;
    input.step = 1;
    input.value = typeof currentValue === 'number' ? Math.min(maxIndex, Math.max(0, currentValue)) : 1;

    setSliderFill(input);

    const knob = document.createElement('div');
    knob.className = 'shq__sliderKnob';
    setKnobPosition(knob, Number(input.value), maxIndex);
    trackWrap.appendChild(input);
    trackWrap.appendChild(knob);

    wrap.appendChild(trackWrap);

    const labels = document.createElement('div');
    labels.className = 'shq__sliderLabels';
    const alternate = q.id === 'q2_clarity' && typeof window !== 'undefined' && window.matchMedia('(min-width: 991px)').matches;
    if (alternate) labels.classList.add('shq__sliderLabels--alternate');

    function updateKnobAndFill() {
      setSliderFill(input);
      setKnobPosition(knob, Number(input.value), maxIndex);
    }

    if (alternate && n === 4) {
      const topRow = document.createElement('div');
      topRow.className = 'shq__sliderLabelsRow shq__sliderLabelsRow--top';
      const bottomRow = document.createElement('div');
      bottomRow.className = 'shq__sliderLabelsRow shq__sliderLabelsRow--bottom';
      
      // Create empty spacer
      const empty = () => {
        const e = document.createElement('span');
        e.className = 'shq__sliderLabelSlot';
        e.setAttribute('aria-hidden', 'true');
        e.textContent = '\u00A0'; // non-breaking space
        return e;
      };
      
      // Top row: labels at positions 0 and 2 (first and third)
      for (let i = 0; i < 4; i++) {
        if (i === 0 || i === 2) {
          const s = document.createElement('span');
          s.className = 'shq__sliderLabel';
          s.textContent = q.labels[i];
          s.setAttribute('data-index', String(i));
          s.addEventListener('click', () => {
            input.value = i;
            updateKnobAndFill();
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          topRow.appendChild(s);
        } else {
          topRow.appendChild(empty());
        }
      }
      
      // Bottom row: labels at positions 1 and 3 (second and fourth)
      for (let i = 0; i < 4; i++) {
        if (i === 1 || i === 3) {
          const s = document.createElement('span');
          s.className = 'shq__sliderLabel';
          s.textContent = q.labels[i];
          s.setAttribute('data-index', String(i));
          s.addEventListener('click', () => {
            input.value = i;
            updateKnobAndFill();
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          bottomRow.appendChild(s);
        } else {
          bottomRow.appendChild(empty());
        }
      }
      
      labels.appendChild(topRow);
      labels.appendChild(bottomRow);
    } else {
      q.labels.forEach((labelText, i) => {
        const s = document.createElement('span');
        s.className = 'shq__sliderLabel';
        s.textContent = labelText;
        s.setAttribute('data-index', String(i));
        s.addEventListener('click', () => {
          input.value = i;
          updateKnobAndFill();
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        labels.appendChild(s);
      });
    }

    wrap.appendChild(labels);

    input.addEventListener('input', () => {
      updateKnobAndFill();
    });

    return {
      el: wrap,
      getValue: () => Number(input.value),
      onChange: (fn) => input.addEventListener('input', fn)
    };
  }

  function renderSingle(root, q, currentValueKey) {
    const list = document.createElement('div');
    list.className = 'shq__optionList';

    q.options.forEach(opt => {
      const row = document.createElement('label');
      row.className = 'shq__option';

      const left = document.createElement('div');
      left.innerHTML = `<strong>${opt.label}</strong>`;

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = q.id;
      input.value = opt.key;
      input.checked = currentValueKey === opt.key;

      row.appendChild(left);
      row.appendChild(input);
      list.appendChild(row);
    });

    return {
      el: list,
      getValue: () => {
        const checked = list.querySelector(`input[name="${q.id}"]:checked`);
        return checked ? checked.value : null;
      },
      onChange: (fn) => list.addEventListener('change', fn)
    };
  }

  function renderMulti(root, q, currentSet, limit = null, allowNoneOption = false) {
    const list = document.createElement('div');
    list.className = 'shq__optionList';
    const selected = new Set(Array.isArray(currentSet) ? currentSet : []);

    q.options.forEach(opt => {
      const row = document.createElement('label');
      row.className = 'shq__option';

      const left = document.createElement('div');
      left.innerHTML = `<strong>${opt.label}</strong>`;

      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = opt.key;
      input.checked = selected.has(opt.key);

      row.appendChild(left);
      row.appendChild(input);
      list.appendChild(row);
    });

    list.addEventListener('change', (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement)) return;

      if (input.checked) {
        selected.add(input.value);

        if (allowNoneOption && input.value === 'none') {
          selected.clear();
          selected.add('none');
          $all(list, 'input[type="checkbox"]').forEach(cb => {
            cb.checked = (cb.value === 'none');
          });
          return;
        }

        if (allowNoneOption && selected.has('none')) {
          selected.delete('none');
          const noneCb = list.querySelector('input[value="none"]');
          if (noneCb) noneCb.checked = false;
        }

        if (limit && selected.size > limit) {
          input.checked = false;
          selected.delete(input.value);
        }
      } else {
        selected.delete(input.value);
      }
    });

    return {
      el: list,
      getValue: () => Array.from(selected),
      onChange: (fn) => list.addEventListener('change', fn)
    };
  }

  function init(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.dataset.quizInit === "1") return;
    root.dataset.quizInit = "1";

    // Required elements
    const cfgEl = root.querySelector('.js-shq-config');
    const startBtn = root.querySelector('.js-shq-start');
    const nameInput = root.querySelector('.js-shq-name');

    const qTitle = root.querySelector('.js-shq-qTitle');
    const qInput = root.querySelector('.js-shq-qInput');
    const nextBtn = root.querySelector('.js-shq-next');
    const backBtn = root.querySelector('.js-shq-back');

    const progressFill = root.querySelector('.js-shq-progressFill');
    const progressMeta = root.querySelector('.js-shq-progressMeta');
    // Build set dots once (one per SET)
if (progressFill && !progressFill.dataset.dots) {
  progressFill.dataset.dots = "1";
  progressFill.innerHTML = Array.from({ length: SETS.length })
    .map(() => `<i class="shq__dot"></i>`)
    .join("");
}


    const restartBtn = root.querySelector('.js-shq-restart');

    // Results UI elements
    const focusChipsEl = root.querySelector('.js-shq-focusChips');
    const whyBulletsEl = root.querySelector('.js-shq-whyBullets');
    const whyBulletsInAccordionEl = root.querySelector('.js-shq-whyBulletsInAccordion');
    const recListEl = root.querySelector('.js-shq-recList');
    const archetypeTitleEl = root.querySelector('.js-shq-archetypeTitle');
    const archetypePatternEl = root.querySelector('.js-shq-archetypePattern');
    const archetypeMessageEl = root.querySelector('.js-shq-archetypeMessage');
    const archetypeBodyWrapEl = root.querySelector('.shq__resultsCardBodyWrap');
    const readMoreBtn = root.querySelector('.js-shq-readMore');
    const archetypeBlockEl = root.querySelector('.js-shq-archetypeBlock');
    const stackSuffixEl = root.querySelector('.js-shq-stackSuffix');
    const ctaTitleEl = root.querySelector('.js-shq-ctaTitle');
    const addAllBtn = root.querySelector('.js-shq-addAll');
    const addAllTextEl = root.querySelector('.js-shq-addAllText');
    const subReasonEl = root.querySelector('.js-shq-subReason');

    const screensContainer = root.querySelector('.js-shq-card') || root.querySelector('.shq__card');

    const missing = [];
    if (!cfgEl) missing.push('.js-shq-config');
    if (!startBtn) missing.push('.js-shq-start');
    if (!nameInput) missing.push('.js-shq-name');
    // email input removed — quiz only asks for first name
    if (!qTitle) missing.push('.js-shq-qTitle');
    if (!qInput) missing.push('.js-shq-qInput');
    if (!nextBtn) missing.push('.js-shq-next');
    if (!backBtn) missing.push('.js-shq-back');
    if (!progressFill) missing.push('.js-shq-progressFill');
    if (!progressMeta) missing.push('.js-shq-progressMeta');
    if (!restartBtn) missing.push('.js-shq-restart');
    if (!screensContainer) missing.push('.js-shq-card');

    if (missing.length) {
      console.warn('[SH Quiz] Missing required elements:', missing, 'Root:', root);
      return;
    }

    // Parse config JSON
    let cfg = null;
    try {
      cfg = JSON.parse(cfgEl.textContent || '{}');
    } catch (e) {
      console.error('[SH Quiz] Invalid JSON in .js-shq-config', e, cfgEl.textContent);
      return;
    }

    // Inject interstitial screen (no Liquid edits needed)
    let interstitial = screensContainer.querySelector('.js-shq-screen[data-screen="interstitial"]');
    if (!interstitial) {
      interstitial = document.createElement('div');
      interstitial.className = 'shq__screen js-shq-screen';
      interstitial.setAttribute('data-screen', 'interstitial');
      interstitial.hidden = true;
      interstitial.innerHTML = `
  <div class="shq__calc">
    <!-- 2) Title -->
    <h1 class="shq__h1 js-shq-inter-title"></h1>

    <!-- 1 + 4) Body paragraphs -->
    <div class="shq__body js-shq-inter-body"></div>

    <!-- 3) Pattern line + Encouragement (no headings) -->
    <div class="shq__resultsBlock js-shq-inter-extra" style="margin-top:18px; display:none;">
      <div class="shq__muted js-shq-inter-patterns" style="margin-bottom:12px;"></div>
      <div class="js-shq-inter-enc"></div>
    </div>

    <!-- Button -->
    <div class="shq__actions" style="margin-top:18px;">
      <button class="shq__btn shq__btn--primary js-shq-inter-next" type="button">
        Continue <span class="shq__btnArrow">→</span>
      </button>
    </div>
  </div>
`;

      screensContainer.appendChild(interstitial);
    }

    const screens = () => $all(root, '.js-shq-screen');
    const showScreen = (name) => {
      screens().forEach(s => {
        const is = s.getAttribute('data-screen') === name;
        s.hidden = !is;
      });
    };

    // state
    let step = -1; // question index (0..16), -1 before first question
    let currentSetIdx = 0;
    const answerState = {};
    let pendingInterstitialAction = null;

    function nameValue() {
      return String(answerState.name || '').trim();
    }
let currentSetIndex = 0;

function getSetIndexForStep(step) {
  for (let i = 0; i < SETS.length; i++) {
    if (step >= SETS[i].start && step <= SETS[i].end) {
      return i;
    }
  }
  return -1;
}


    function setKicker(text) {
      const el = interstitial.querySelector('.js-shq-inter-kicker');
      if (!el) return;
      el.textContent = text || '';
      el.style.display = text ? '' : 'none';
    }

    function setInterstitialContent({ kicker, title, bodyParagraphs, showExtra, extraPatterns, extraMessages, primaryLabel }) {
      setKicker(kicker);

      const tEl = interstitial.querySelector('.js-shq-inter-title');
      const bEl = interstitial.querySelector('.js-shq-inter-body');
      const extraEl = interstitial.querySelector('.js-shq-inter-extra');
      const patternsEl = interstitial.querySelector('.js-shq-inter-patterns');
      const encEl = interstitial.querySelector('.js-shq-inter-enc');
      const nextEl = interstitial.querySelector('.js-shq-inter-next');

      if (tEl) tEl.textContent = title || '';
      if (bEl) {
        bEl.innerHTML = (bodyParagraphs || []).map(p => `<p>${p}</p>`).join('');
      }

      if (nextEl) nextEl.innerHTML = `${primaryLabel || 'Continue'} <span class="shq__btnArrow">→</span>`;
      if (interstitial) interstitial.dataset.variant = (primaryLabel === 'Start') ? 'start' : 'continue';


      if (extraEl) extraEl.style.display = showExtra ? '' : 'none';
      if (patternsEl) patternsEl.textContent = extraPatterns || '';
      if (encEl) {
        encEl.innerHTML = (extraMessages || []).map(m => `<p>${m}</p>`).join('');
      }
    }

    function showInterstitial(payload, onContinue) {
      pendingInterstitialAction = typeof onContinue === 'function' ? onContinue : null;
      setInterstitialContent(payload);
      showScreen('interstitial');
      scrollQuizIntoView(root);
    }

   

    function startSetIntro(setIdx) {
      currentSetIdx = setIdx;
      const set = SETS[setIdx];

      const nm = nameValue();
      const kicker = nm ? `Hi ${nm},` : '';

      showInterstitial(
        {
          kicker,
          title: set.introTitle,
          bodyParagraphs: set.introBody,
          showExtra: false,
          primaryLabel: (setIdx === 0) ? "Start" : "Continue"
        },
        () => {
          // Show first question of this set
          step = set.start;
          showScreen('question');
          renderCurrent();
        }
      );
    }

    function showSetOutro(setIdx, afterAction /* 'nextSet' | 'calculate' */) {
      const set = SETS[setIdx];

      // Scores up to end of set
      const scoresSoFar = computeDomainScores(answerState, set.end);
      const maxSoFar = maxPointsPerDomainThroughIndex(set.end);

      const patterns = humanDomainList(topDomains(scoresSoFar, 3));
      const patternsLine = patterns.length ? `So far, your answers most strongly point toward: ${patterns.join(" · ")}.` : "";

      const encouragement = getEncouragementForSet(setIdx, scoresSoFar, maxSoFar);

      const nm = nameValue();
      const kicker = nm ? `${nm}, quick update` : 'Quick update';

      showInterstitial(
        {
          kicker,
          title: set.outroTitle,
          bodyParagraphs: set.outroBody,
          showExtra: true,
          extraPatterns: patternsLine,
          extraMessages: encouragement,
          primaryLabel: (setIdx === SETS.length - 1) ? "See my results" : "Continue"
        },
        () => {
          if (afterAction === 'calculate') {
            calculateAndShowResults();
            return;
          }

          // Move into next set intro
          const nextSetIdx = Math.min(setIdx + 1, SETS.length - 1);
          startSetIntro(nextSetIdx);
        }
      );
    }

    function saveQuizResultsToStorage({ focus, picks, domainScores }) {
      try {
        const payload = {
          v: 1,
          ts: Date.now(),
          focus,
          picks: picks.map(p => ({ key: p.key, score: Math.round(p.score) })),
          domainScores
        };
        sessionStorage.setItem('sh_quiz_results', JSON.stringify(payload));
      } catch (e) {}
    }

   function updateProgress() {
  const totalQuestions = QUESTIONS.length;

  // Keep aria progress accurate (accessibility)
  const percent = step < 0 ? 0 : Math.round(((step + 1) / totalQuestions) * 100);
  root.querySelector('.shq__progressBar')
    ?.setAttribute('aria-valuenow', String(percent));

  // Set-based progress (human-friendly)
  const totalSets = SETS.length;
  const setIdx = getSetIndexForStep(step);
  const prettySet = setIdx >= 0 ? (setIdx + 1) : 1;

  // Text: "Set 1 of 5"
  if (progressMeta) {
    progressMeta.textContent = `Set ${prettySet} of ${totalSets}`;
  }

  // Fill dots up to current set
  if (progressFill) {
    const dots = progressFill.querySelectorAll('.shq__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-done', i < prettySet);
      dot.classList.toggle('is-current', i === (prettySet - 1));
    });
  }
}


    function canProceedFor(q) {
      const ans = answerState[q.id];
      if (q.type === 'slider4' || q.type === 'slider3') return typeof ans === 'number';
      if (q.type === 'single') return !!(ans && ans.key);
      if (q.type === 'multi') return Array.isArray(ans) && ans.length > 0;
      if (q.type === 'multi_optional') return true;
      if (q.type === 'multi_limit') return Array.isArray(ans) && ans.length > 0 && ans.length <= (q.limit || 99);
      if (q.type === 'checkbox') return ans === true;
      return false;
    }

    function renderCurrent() {
      const q = QUESTIONS[step];
      qTitle.innerHTML = formatQuestionTitle(q.title, q.keyWord);
      qInput.innerHTML = '';

      let widget = null;

      if (q.type === 'slider4' || q.type === 'slider3') {
        const current = typeof answerState[q.id] === 'number' ? answerState[q.id] : 1;
        widget = renderSlider(root, q, current);
        widget.onChange(() => {
          answerState[q.id] = widget.getValue();
          nextBtn.disabled = !canProceedFor(q);
        });
        answerState[q.id] = current;
      }

      if (q.type === 'single') {
        widget = renderSingle(root, q, answerState[q.id]?.key || null);
        widget.onChange(() => {
          const key = widget.getValue();
          const opt = q.options.find(o => o.key === key);
          answerState[q.id] = opt ? { key: opt.key, pts: opt.pts } : null;
          nextBtn.disabled = !canProceedFor(q);
        });
      }

      if (q.type === 'multi') {
        widget = renderMulti(root, q, answerState[q.id] || []);
        widget.onChange(() => {
          answerState[q.id] = widget.getValue();
          nextBtn.disabled = !canProceedFor(q);
        });
      }

      if (q.type === 'multi_optional') {
        widget = renderMulti(root, q, answerState[q.id] || [], null, true);
        widget.onChange(() => {
          answerState[q.id] = widget.getValue();
          nextBtn.disabled = false;
        });
      }

      if (q.type === 'multi_limit') {
        widget = renderMulti(root, q, answerState[q.id] || [], q.limit || 3);
        widget.onChange(() => {
          answerState[q.id] = widget.getValue();
          nextBtn.disabled = !canProceedFor(q);
        });
      }

      if (q.type === 'checkbox') {
        const wrap = document.createElement('div');
        wrap.className = 'shq__optionList';

        const row = document.createElement('label');
        row.className = 'shq__option';

        const left = document.createElement('div');
        left.innerHTML = `<strong>${q.checkboxLabel}</strong>`;

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.checked = !!answerState[q.id];

        row.appendChild(left);
        row.appendChild(input);
        wrap.appendChild(row);

        input.addEventListener('change', () => {
          answerState[q.id] = input.checked;
          nextBtn.disabled = !canProceedFor(q);
        });

        widget = { el: wrap, getValue: () => input.checked };
      }

      if (widget) qInput.appendChild(widget.el);

      backBtn.style.visibility = (step <= 0) ? 'hidden' : 'visible';
      nextBtn.disabled = !canProceedFor(q);
      updateProgress();
      scrollQuizIntoView(root);
    }

    let lastComputed = null; // { focus, picks, recKeys, recTitles, domainScores, items, primaryArchetype, picksWithBenefits }

    function renderResultsUI(focus, recKeys, primaryArchetype, picksWithBenefits) {
      if (archetypeTitleEl) archetypeTitleEl.textContent = primaryArchetype ? (primaryArchetype.headline || primaryArchetype.label) : '';
      if (archetypePatternEl) archetypePatternEl.textContent = primaryArchetype ? (primaryArchetype.patternLabel || primaryArchetype.label) : '';
      const messageText = primaryArchetype ? (primaryArchetype.topLine || '') : '';
      if (archetypeMessageEl) archetypeMessageEl.textContent = messageText;
      if (archetypeBodyWrapEl) {
        archetypeBodyWrapEl.classList.remove('shq__resultsCardBodyWrap--expanded');
        if (readMoreBtn) {
          readMoreBtn.setAttribute('aria-expanded', 'false');
          readMoreBtn.textContent = 'Read more';
          readMoreBtn.hidden = messageText.length < 120;
        }
      }
      if (archetypeBlockEl) archetypeBlockEl.hidden = !primaryArchetype;

      if (focusChipsEl) {
        focusChipsEl.textContent = primaryArchetype && primaryArchetype.focusLine
          ? primaryArchetype.focusLine
          : (focus && focus.length) ? (focus || []).map((t) => DOMAIN_LABELS[t] || t).join(" · ") : '';
      }

      if (whyBulletsEl) {
        whyBulletsEl.innerHTML = '';
        const recItems = Array.isArray(picksWithBenefits) && picksWithBenefits.length ? picksWithBenefits : (recKeys || []).map((key) => ({ key, role: "", benefit: null }));
        recItems.forEach((item) => {
          const prod = cfg && cfg.products ? cfg.products[item.key] : null;
          const title = prod && prod.title ? String(prod.title) : String(item.key);
          const benefit = item.benefit || item.role || '';
          const li = document.createElement('li');
          li.innerHTML = benefit ? `<strong>${escapeHtml(title)}</strong> ${escapeHtml(benefit)}` : `<strong>${escapeHtml(title)}</strong>`;
          whyBulletsEl.appendChild(li);
        });
      }

      if (whyBulletsInAccordionEl) {
        whyBulletsInAccordionEl.innerHTML = '';
        const bullets = (primaryArchetype && primaryArchetype.whyBullets && primaryArchetype.whyBullets.length) ? primaryArchetype.whyBullets : [
          "Based on how your energy, clarity, and recovery are tracking right now.",
          "Designed as a simple foundation you can be consistent with."
        ];
        bullets.forEach((b) => {
          const li = document.createElement('li');
          li.textContent = b;
          whyBulletsInAccordionEl.appendChild(li);
        });
      }

      if (stackSuffixEl) stackSuffixEl.textContent = primaryArchetype && primaryArchetype.stackSuffix ? primaryArchetype.stackSuffix : 'to stabilize and refine';

      const recItems = Array.isArray(picksWithBenefits) && picksWithBenefits.length ? picksWithBenefits : (recKeys || []).map((key) => ({ key, role: "", benefit: null }));
      if (recListEl) {
        recListEl.innerHTML = '';
        recItems.forEach((item, i) => {
          if (i > 0) {
            const plus = document.createElement('span');
            plus.className = 'shq__recPlus';
            plus.textContent = '+';
            recListEl.appendChild(plus);
          }
          const key = item.key || item;
          const role = item.role || "";
          const benefit = item.benefit || "";
          const prod = cfg && cfg.products ? cfg.products[key] : null;
          const title = prod && prod.title ? String(prod.title) : String(key);
          const url = prod && prod.url ? String(prod.url) : '';
          const img = prod && prod.image ? String(prod.image) : '';
          const row = document.createElement('div');
          row.className = 'shq__rec';
          const descText = benefit || role;
          const roleContent = descText ? escapeHtml(descText) : '';
          row.innerHTML = `
            <div class="shq__recInner">
              ${img ? `<div class="shq__recImg"><img src="${escapeHtml(img)}" alt="${escapeHtml(title)}" loading="lazy"></div>` : ''}
              <div class="shq__recText">
                ${url ? `<a class="shq__recTitle" href="${escapeHtml(url)}">${escapeHtml(title)}</a>` : `<div class="shq__recTitle">${escapeHtml(title)}</div>`}
                <div class="shq__recDescBox"><span class="shq__recRole">${roleContent}</span></div>
              </div>
            </div>
          `;
          recListEl.appendChild(row);
        });
      }

      if (ctaTitleEl) ctaTitleEl.textContent = primaryArchetype && primaryArchetype.ctaHeading ? primaryArchetype.ctaHeading : 'Your Personalized Core System is Ready to Start!';
      const addAllTextLabel = primaryArchetype && primaryArchetype.ctaLabel ? primaryArchetype.ctaLabel : 'Add My Core Maintenance System to Cart';
      $all(root, '.js-shq-addAllText').forEach(el => { el.textContent = addAllTextLabel; });
      if (subReasonEl) {
        subReasonEl.textContent = primaryArchetype && primaryArchetype.subscriptionLine ? primaryArchetype.subscriptionLine : "Start your 'Maintenance System' today for consistent, lasting balance.";
        subReasonEl.style.display = 'block';
      }
    }

    // Read more / Read less for Primary pattern body
    if (readMoreBtn && archetypeBodyWrapEl && !readMoreBtn.dataset.bound) {
      readMoreBtn.dataset.bound = "1";
      readMoreBtn.addEventListener('click', () => {
        const expanded = archetypeBodyWrapEl.classList.toggle('shq__resultsCardBodyWrap--expanded');
        readMoreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        readMoreBtn.textContent = expanded ? 'Read less' : 'Read more';
      });
    }

    // Hook up all "Add to cart" buttons (Block 3 fourth block + Block 4 CTA)
    const addAllBtns = $all(root, '.js-shq-addAll');
    addAllBtns.forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!lastComputed || !lastComputed.items || !lastComputed.items.length) return;

        addAllBtns.forEach(b => { b.disabled = true; });

        try {
          await addToCart(
            lastComputed.items,
            (cfg && cfg.redirect_url) ? cfg.redirect_url : '/cart',
            true
          );
        } catch (err) {
          console.error(err);
          alert('Sorry — something prevented adding items to cart. Please try again.');
          addAllBtns.forEach(b => { b.disabled = false; });
        }
      });
    });

    // Share block: invite link (native share or copy) — stays on page, no redirect
    const shareInviteBtn = root.querySelector('.js-shq-share-invite');
    const shareCopyBtn = root.querySelector('.js-shq-share-copy');
    const shareFeedbackEl = root.querySelector('.js-shq-share-feedback');
    function getShareUrl() {
      const section = root.closest('section');
      const url = (section && section.dataset.quizUrl) ? section.dataset.quizUrl : (window.location.origin + window.location.pathname);
      return url.replace(/#.*$/, '');
    }
    function showShareFeedback() {
      if (!shareFeedbackEl) return;
      shareFeedbackEl.hidden = false;
      shareFeedbackEl.textContent = 'Link copied';
      const t = setTimeout(() => { shareFeedbackEl.hidden = true; shareFeedbackEl.textContent = ''; }, 2500);
      shareFeedbackEl._feedbackTimeout = t;
    }
    async function copyShareLink() {
      const url = getShareUrl();
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        showShareFeedback();
      } catch (e) {
        console.warn('[SH Quiz] Copy failed', e);
      }
    }
    async function handleShareInvite() {
      const url = getShareUrl();
      const title = (typeof document !== 'undefined' && document.title) ? document.title : 'Health Foundations Assessment';
      const text = 'I found this assessment helpful — you might too.';
      if (navigator.share) {
        try {
          await navigator.share({ title, text, url });
          if (shareFeedbackEl) {
            shareFeedbackEl.textContent = 'Shared';
            shareFeedbackEl.hidden = false;
            setTimeout(() => { shareFeedbackEl.hidden = true; shareFeedbackEl.textContent = ''; }, 2500);
          }
        } catch (e) {
          if (e.name !== 'AbortError') {
            await copyShareLink();
          }
        }
      } else {
        await copyShareLink();
      }
    }
    if (shareInviteBtn && !shareInviteBtn.dataset.bound) {
      shareInviteBtn.dataset.bound = '1';
      shareInviteBtn.addEventListener('click', (e) => { e.preventDefault(); handleShareInvite(); });
    }
    if (shareCopyBtn && !shareCopyBtn.dataset.bound) {
      shareCopyBtn.dataset.bound = '1';
      shareCopyBtn.addEventListener('click', (e) => { e.preventDefault(); copyShareLink(); });
    }

    async function calculateAndShowResults() {
      showScreen('calculating');
      updateProgress();
      scrollQuizIntoView(root);

      window.setTimeout(async () => {
        try {
          const domainScores = computeDomainScores(answerState);
          const focus = topDomains(domainScores, 3);

          const picks = scoreProducts(domainScores, (cfg && cfg.products) ? cfg.products : {});
          const recKeys = picks.map(p => p.key);

          const { primary: primaryArchetype } = resolvePrimaryArchetype(domainScores);
          const picksWithBenefits = picks.map((p) => ({
            key: p.key,
            ...getArchetypeBenefitForProduct(primaryArchetype.id, p.key)
          }));

          saveQuizResultsToStorage({ focus, picks, domainScores });

          const recTitles = recKeys.map((key) => {
            const prod = cfg && cfg.products ? cfg.products[key] : null;
            return prod && prod.title ? String(prod.title) : String(key);
          });

          await updateQuizCustomerWithResults(
            answerState.name || '',
            answerState.email || '',
            recTitles,
            cfg
          );

          // Store quiz results to cart (and sessionStorage) before showing results screen.
          // Data is captured even if the user never clicks "Add recommendations to cart".
          const { q16: q16Label, q16a: q16aLabel } = getQ16Q16aLabels(QUESTIONS, answerState);
          await saveQuizToCartAttributes({
            v: 1,
            focus,
            picks: recTitles,
            ts: Date.now(),
            q16: q16Label,
            q16a: q16aLabel,
            name: answerState.name || '',
            email: answerState.email || ''
          });

          // ✅ Quiz-only rule: ALWAYS default to subscription for adds
          const useSub = true;

          const items = [];
          for (const key of recKeys) {
            const prod = cfg && cfg.products ? cfg.products[key] : null;
            if (!prod || !prod.variant_id) continue;

            const payload = { id: Number(prod.variant_id), quantity: 1 };

            if (useSub) {
              const productUrl = prod && prod.url ? String(prod.url) : "";
              const plans = await __getShopifySellingPlanIdsForProduct(productUrl);

              if (!plans || !plans.length) {
                console.error('[SH Quiz] No Shopify selling plans found for product:', key, { url: productUrl, prod });
                throw {
                  status: 422,
                  message: 'Subscription add failed',
                  description: 'Selling plan could not be applied (no Shopify selling plan IDs found)',
                  raw: { key, url: productUrl, prod }
                };
              }

              payload.__planCandidates = plans;
              console.log('[SH Quiz] plan candidates', { key, variant_id: payload.id, plans });
            }

            items.push(payload);
          }

          if (!items.length) {
            throw { message: 'No valid products configured for picks.' };
          }

          lastComputed = { focus, picks, recKeys, recTitles, domainScores, items, primaryArchetype, picksWithBenefits };

          showScreen('results');
          renderResultsUI(focus, recKeys, primaryArchetype, picksWithBenefits);
          nextBtn.disabled = false;

        } catch (e) {
          console.error(e);
          alert('Sorry — something prevented showing results. Please try again.');
          showScreen('question');
          renderCurrent();
        }
      }, 250);
    }

function goNext() {
  if (step < 0) return;

  const q = QUESTIONS[step];
  if (!canProceedFor(q)) return;

  const setIdx = getSetIndexForStep(step);
  const set = SETS[setIdx];

  const isLastQuestion = step === QUESTIONS.length - 1;
  const isEndOfSet = step === set.end;
  const isLastSet = setIdx === SETS.length - 1;

  // ✅ FINAL QUESTION (Q17) → SKIP OUTRO → CALCULATE
  if (isLastQuestion && isLastSet) {
    calculateAndShowResults();
    return;
  }

  // END OF A NON-FINAL SET → show set outro
  if (isEndOfSet) {
    showSetOutro(setIdx, 'nextSet');
    return;
  }

  // NORMAL FLOW → next question
  step += 1;
  renderCurrent();
}




    function goBack() {
      if (step <= 0) return;
      step -= 1;
      renderCurrent();
    }

    // Interstitial continue
    const interNext = interstitial.querySelector('.js-shq-inter-next');
    if (interNext && !interNext.dataset.bound) {
      interNext.dataset.bound = "1";
      interNext.addEventListener('click', (e) => {
        e.preventDefault();
        const fn = pendingInterstitialAction;
        pendingInterstitialAction = null;
        if (typeof fn === 'function') fn();
      });
    }

    // events
    startBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const name = (nameInput?.value || '').trim();

      answerState.name = name;
      answerState.email = '';

      if (name) registerQuizLead(name, '', cfg);

      // start with Set 1 intro
      step = -1;
      currentSetIdx = 0;
      updateProgress();
      startSetIntro(0);
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goNext();
    });

    backBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goBack();
    });

    restartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      for (const k in answerState) delete answerState[k];
      step = -1;
      currentSetIdx = 0;
      showScreen('intro');
      updateProgress();
      scrollQuizIntoView(root);
    });

    const rawCheat = typeof URLSearchParams !== 'undefined' && new URLSearchParams(document.location.search).get('quiz_cheat');
    const cheatParam = rawCheat && String(rawCheat).toLowerCase();
    const cheatOn = cheatParam === '1' || cheatParam === 'true' || cheatParam === 'yes';
    const products = (cfg && cfg.products && typeof cfg.products === 'object') ? cfg.products : {};
    if (cheatOn && cfg) {
      showScreen('calculating');
      updateProgress();
      (async function cheatToResults() {
        try {
          const domainScores = { Energy: 2, Recovery: 2, Focus: 1, Mood: 1 };
          const focus = topDomains(domainScores, 3);
          const picks = scoreProducts(domainScores, products);
          const recKeys = picks.map((p) => p.key);
          const { primary: primaryArchetype } = resolvePrimaryArchetype(domainScores);
          const picksWithBenefits = picks.map((p) => ({ key: p.key, ...getArchetypeBenefitForProduct(primaryArchetype.id, p.key) }));
          const recTitles = recKeys.map((key) => (products[key] && products[key].title) ? String(products[key].title) : String(key));
          const items = [];
          for (const key of recKeys) {
            const prod = products[key];
            if (!prod || !prod.variant_id) continue;
            const payload = { id: Number(prod.variant_id), quantity: 1 };
            try {
              const productUrl = prod.url ? String(prod.url) : '';
              const plans = await __getShopifySellingPlanIdsForProduct(productUrl);
              if (plans && plans.length) payload.__planCandidates = plans;
            } catch (_) {}
            items.push(payload);
          }
          lastComputed = { focus, picks, recKeys, recTitles, domainScores, items, primaryArchetype, picksWithBenefits };
          showScreen('results');
          renderResultsUI(focus, recKeys, primaryArchetype, picksWithBenefits);
          nextBtn.disabled = false;
          scrollQuizIntoView(root);
        } catch (e) {
          console.error('[SH Quiz] Cheat to results failed:', e);
          showScreen('intro');
          updateProgress();
        }
      })();
    } else {
      showScreen('intro');
      updateProgress();
    }
  }

  function boot(context) {
    const scope = (context && context.querySelectorAll) ? context : document;
    scope.querySelectorAll('.shq').forEach((el) => init(el));
  }

  const runBoot = () => boot(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBoot);
  } else {
    runBoot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
